import React from 'react';

import moment from 'moment';
import RRule from 'rrule';

import {HeadingText} from 'app/components/general/HeadingText';
import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {TooltipList} from 'app/components/general/TooltipList';
import {getRepetitionLabel} from 'app/tasks/utils';
import {gt} from 'app/utils/i18n';

interface Props {
  rrule: RRule;
}

export function RRuleRepetitionLabel({rrule}: Props): JSX.Element {
  const label = React.useMemo(() => getRepetitionLabel('', rrule), [rrule]);
  const isOnceOnly = rrule.options.count === 1;

  return (
    <div className="border-top py-4">
      <div className="col-12 text-center">
        <HeadingText className="mr-1" light>
          {gt('Task repetition')}:
        </HeadingText>
        <b>{label}</b>
      </div>
      {!isOnceOnly ? (
        <>
          <div className="col-12 mt-2 text-center">
            <HeadingText className="mr-1" light>
              {gt('First occurrence')}:
            </HeadingText>
            <LazyTooltip
              hide={isOnceOnly}
              tooltip={
                <TooltipList
                  title={gt('First 10 occurrences:')}
                  items={rrule
                    .all((_, i) => i < 10)
                    .map((date) => {
                      const dateStr = moment(date).format('llll');
                      return {id: dateStr, name: dateStr};
                    })}
                />
              }
            >
              <span
                style={{borderBottom: '1px dotted #666'}}
                className="font-weight-bold"
              >
                {moment(rrule.all((_, i) => i < 1)[0]).format('ll')}
              </span>
            </LazyTooltip>
          </div>
        </>
      ) : null}
    </div>
  );
}
